import { ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';

export class RecruitmentSummaryModel extends Model implements IModel<RecruitmentSummaryModel> {
  public openPositions: number = 0;
  public averageDaysOpen: number = 0;
  public pausedPositions: number = 0;
  public draftPositions: number = 0;

  static create(input: any): RecruitmentSummaryModel {
    return ObjectMapper.deserialize<RecruitmentSummaryModel>(
      RecruitmentSummaryModel,
      input ?? {}
    );
  }
}
